<template>
  <tr>
    <th>
      <p class="lib-mt-5 sub-goods-title">
        <label>
          <input type="checkbox"
                 v-model="isCheckedSubGoods"
          >
          <span class="ml-5">{{displayName}}</span>
        </label>
      </p>
      <InformationBadge
          v-show="!!informationUrl"
          :information-url="informationUrl"></InformationBadge>
    </th>
    <td :class="{disabled: !isCheckedSubGoods}">
      <div class="hw-input-wrap">
        <div class="select-wrapper hw-input-wrap w-70">
          <select class="hw-input"  v-model="selectedTypeId" :disabled="!isCheckedSubGoods">
            <option v-for="optionInfo in optionValueList"
                    :value="optionInfo.typeId"
                    :key="optionInfo.typeId"> {{optionInfo.displayName}} </option>
          </select>
        </div>
      </div>

    </td>
    <td :class="{disabled: !isCheckedSubGoods}" class="text-right primary-gray-color">{{retailPrice | numberFormat}}원/1회</td>
  </tr>
</template>

<script>
import _ from 'lodash'
import InformationBadge from "@/components/step1/GoodsTable/SubGoodsTemplate/InformationBadge"

export default {
  name: "Id3",
  components:{
    InformationBadge
  },
  data(){
    return {
      localQuantity : 1,
      isCheckedSubGoods : false,
      selectedTypeId : null,
    }
  },
  mounted() {
    this.selectedTypeId = this.optionValueList[0].typeId

    // selectgoods가 있을때는 check도 true이고 해당 select goods 를 선택한상태
    if(this.selectGoodsId){
      let selectedSubGoodsInfo = this.subGoodsInfoList.find(subGoodsInfo => {
        return parseInt(subGoodsInfo.id) === this.selectGoodsId
      })
      if(selectedSubGoodsInfo){
        this.selectedTypeId = selectedSubGoodsInfo.id
        this.$nextTick(()=>{
          this.isCheckedSubGoods = true
        })
      }
    }
    // selectgoods가 없을때는 check는 false이고 해당 defaultSelectGoodsInfo 값을 선택한상태
    else{
      this.defaultSelectGoodsList.forEach(defaultSelectGoodsInfo => {
        this.optionValueList.forEach(optionInfo => {
          if( parseInt(optionInfo.typeId) === parseInt(defaultSelectGoodsInfo.goods_id) ){
            this.selectedTypeId = defaultSelectGoodsInfo.goods_id
            console.log(this.selectedTypeId)
          }
        })
      })
    }
  },
  props: {
    subGoodsCompositionInfo: {
      type: Object
    },
    subGoodsInfoList: {
      type: Array,
    },
    displayInfo: {
      type: Object,
    },
    defaultSelectGoodsList: {
      type: Array,
    },
    selectGoodsId : {
      type : Number
    },
  },
  watch: {
    selectedTypeId (selectedTypeId, oldSelectedTypeId) {
      if(this.isCheckedSubGoods){
        if(oldSelectedTypeId){
          this.removeSubGoods(oldSelectedTypeId)
        }
        this.addSubGoods()
      }
    },
    isCheckedSubGoods (isChecked) {
      if(isChecked){
        this.addSubGoods()
      } else{
        this.removeSubGoods(this.selectedTypeId)
      }
    },
  },
  computed:{
    mainGoodsId(){
      return parseInt(this.subGoodsCompositionInfo.main_goods_id)
    },
    perVolume(){
      return null
    },
    optionValueList(){
      let optionValueList =
          _.chain(this.subGoodsCompositionInfo.rule.group)
          .orderBy((compositionGroupInfo) => parseInt(compositionGroupInfo.sort), ['asc'])
          .flatMap((compositionGroupInfo) => {
            return {
              displayName : compositionGroupInfo.display_name,
              fullDisplayName : compositionGroupInfo.full_display_name,
              typeId : parseInt(compositionGroupInfo.type_id),
            }
          })
          .value()

      return optionValueList
    },
    displayName(){
      return this.subGoodsCompositionInfo.rule.display_name
    },
    informationUrl() {
      return this.displayInfo.data
    },
    findSubGoodsInfo(){
      return _.find(this.subGoodsInfoList, (subGoodsInfo)=>{
        return parseInt(subGoodsInfo.id) === parseInt(this.selectedTypeId)
      });
    },
    retailPrice(){
      if(this.findSubGoodsInfo){
        return this.findSubGoodsInfo.retail_price
      }
      return 0
    },
    volumeUnit(){ // resources를 정렬한 것 중 첫번째의 volume_unit이 단위
      return this.findSubGoodsInfo.resources[0]['volume_unit']
    },
    localVolume(){
      if(this.findSubGoodsInfo){
        return parseInt(this.findSubGoodsInfo.resources[0].volume)
      }
      return 0
    },
    sort(){
      return parseInt(this.subGoodsCompositionInfo.sort)
    }
  },
  methods:{
    addSubGoods(){
      this.$emit('add-sub-goods', {
        main_goods_id: this.mainGoodsId,
        id: this.selectedTypeId,
        quantity: parseInt(this.localQuantity),
        volume: parseInt(this.localVolume),
        cost: this.retailPrice,
        per_volume: this.perVolume,
        sort: this.sort,
        name : this.displayName,
        volume_unit : this.volumeUnit,
        term_unit : this.findSubGoodsInfo.term_unit,
      })
    },
    removeSubGoods(selectedTypeId){
      this.$emit('remove-sub-goods', selectedTypeId)
    },
  }
}
</script>

<style scoped>
.sub-goods-title{
  float:left;
}
</style>